import * as React from "react";
import {authorize} from "@athena-portal/components";
import FalconFooter from "../../../components/navigation/FalconFooter";
import FalconHeader from "../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../utils/PluginTemplates";
import {CancelPolicyOrAutomaticRenewalChoiceWidget} from "../../../components/widgets/CancelPolicyOrAutomaticRenewalChoiceWidget";
import {RouteComponentProps} from "react-router";
import {NextButton} from "../subscription/motor/motorClaims/NextButton";
import {INTERACTION_PROCESS_RENEWAL_CANCELLATION} from "@falcon/services";

interface IProps extends RouteComponentProps<{}> {
    location: any;
}

interface IState {
    customerChoice: string;
}

@authorize
export class CancelPolicyOrAutomaticRenewalPage
    extends React.Component<IProps, IState> {

    private pluginTemplates = new PluginTemplates();
    private mtcJourneyUrl: string;
    private renewalCancellationUrl: string;
    private pageTitle: string;
    private isRenewalCancellation: boolean;

    constructor(props: IProps) {
        super(props);

        this.state = {
            customerChoice: "",
        };

        this.mtcJourneyUrl = this.props.location.state.mtcJourneyUrl;
        this.renewalCancellationUrl = this.props.location.state.renewalCancellationUrl;
        this.pageTitle = this.props.location.state.pageTitle;
        this.isRenewalCancellation = this.props.location.state.isRenewalCancellation;
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle(this.pageTitle);
    }

    public render(): React.ReactNode {

        if (this.isRenewalCancellation) {
            window.sessionStorage.setItem("referrerJourney", INTERACTION_PROCESS_RENEWAL_CANCELLATION);
            this.props.history.push(this.renewalCancellationUrl);
        }
        const questionTitle: string = this.props.location.state.questionTitle;

        return (
            <>
                <FalconHeader/>
                <div className="page-contents">
                    {this.pluginTemplates.renderBackLink("Back", true)}
                    <h1 className="page-heading-white">{this.pageTitle}</h1>
                    <CancelPolicyOrAutomaticRenewalChoiceWidget
                        questionTitle={questionTitle}
                        handleChoiceFunc={this.handleChoiceFunc}
                    />

                    <NextButton buttonId={"next"}
                                disabled={!this.state.customerChoice}
                                wrapperClass="padding-right-left-0"
                                onClick={this.handleNext}/>
                    {this.pluginTemplates.renderBackLink("Back", false)}
                </div>
                <FalconFooter/>
            </>
        );
    }

    private handleChoiceFunc = (choice: string): void => {
        this.setState({customerChoice: choice});
    };

    private handleNext = (event: any): void => {
        if (event.target.disabled) {
            event.preventDefault();
        } else if (this.state.customerChoice === CancelPolicyOrAutomaticRenewalChoiceWidget.CANCEL_OPT_EXISTING_POLICY) {
            this.props.history.push(this.mtcJourneyUrl);
        } else {
            this.props.history.push(this.renewalCancellationUrl);
        }
    };

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/CancelPolicyOrAutomaticRenewalPage.tsx